module.exports = __webpack_public_path__ + "img/ico_timed.43c43359.svg";